import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { StaticPageContentService } from "../services";

const PrivacyPolicy = () => {
 // const { name } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    getData("privacy-policy");
  }, []);

  const getData = async (privacypolicy) => {
    try {
      const res = await StaticPageContentService.getStaticPageByUrl(
        privacypolicy
      );
      if (res?.isSuccess && res?.data?.content?.length > 0) {
        const decodedHtml = decodeHtml(res?.data?.content);
        setData(decodedHtml);
      } else {
      }
    } catch (error) {}
  };

  const decodeHtml = (html) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  };

  return (
    <>
      <section className="account-login">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="account-profile">
                <h4>Privacy Policy</h4>
                <div className="account-profile1"></div>
              </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="account-profile second">
                <h5>
                  <span style={{ height: "40px" }}></span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="row">
        <div className="col-12">
          <div className="account-profile editor-container">
            <div
              className="editor-content"
              dangerouslySetInnerHTML={{ __html: data }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
